export default __webpack_public_path__ + "static/media/07.411e6ab9.png";